// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "@reach/router";
import PageHeader from "../../../components/PageHeader";
import PageTitle from "../../../components/PageTitle";
import PageBody from "../../../components/PageBody";
import AddUserForm from "./AddUserForm";
const AddUserScreen: React.FunctionComponent<RouteComponentProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader>
        <PageTitle title={t("add_users.title")} />
      </PageHeader>
      <PageBody>
        <AddUserForm />
      </PageBody>
    </>
  );
};

export default AddUserScreen;
